import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable({
    providedIn: 'root'
})
export class MfaPendingAuthGuard implements CanActivate {

    constructor(
        private _authService: AuthService,
        private _router: Router
    ) {}

    canActivate(): boolean | UrlTree {
        if (this._authService.hasPendingMfaAuth) {
            return true;
        }

        return this._router.createUrlTree(['/sign-in']);
    }
}
